<template>
    <div class="three-cols-box">
       <settings-column :titles="titles[0]" :emails="inmarsat.emails" :content="inmarsat.content" :subject="inmarsat.subject" ref="inmarsat"/>
       <settings-column :titles="titles[1]" :emails="billing.emails" :content="billing.content" :subject="billing.subject" ref="billing" />
       <settings-column  :titles="titles[2]" :emails="mss.emails" :content="mss.content" :subject="mss.subject" ref="mss"/>
    </div>
    <div class="codes-box">
        <p class="title">You may use the following short codes:</p>
        <div class="links-box">
            <a href="#" @click.prevent="shorcodeClick('%company%')">%company%</a>,
            <a href="#" @click.prevent="shorcodeClick('%terminal%')">%terminal%</a>,
            <a href="#" @click.prevent="shorcodeClick('%date%')">%date%</a>,
            <a href="#" @click.prevent="shorcodeClick('%starttime%')">%starttime%</a>,
            <a href="#" @click.prevent="shorcodeClick('%finishtime%')">%finishtime%</a>,
            <a href="#" @click.prevent="shorcodeClick('%location%')">%location%</a>,
            <a href="#" @click.prevent="shorcodeClick('%subscription%')">%subscription%</a>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex"

import SettingsColumn from "./SettingsColumn";
export default {
    name: 'email-settings',

    components: {SettingsColumn},

    data() {
        return {
            titles: [
                {
                    main: "Inmarsat Settings",
                    emails: "Inmarsat Emails",
                    subject: "Inmarsat Subject",
                    content: "Email Content",
                    settings: 'inmarsat'
                },
                {
                    main: "Marlink Billing",
                    subject: "Billing Subject",
                    emails: "Billing Emails",
                    content: "Email Content",
                    settings: 'billing'
                },
                {
                    main: "MSS Service Manager",
                    subject: "MSS Subject",
                    emails: "MSS Emails",
                    content: "Email Content",
                    settings: 'mss'
                },
            ],
        }
    },

    mounted() {
        this.getEmailSettings();
    },

    computed: {
        ...mapState('settings', [
            'inmarsat',
            'billing',
            'mss'
        ]),
    },

    methods: {
        ...mapActions('settings', [
            'getEmailSettings'
        ]),
        shorcodeClick(val) {
            this.$refs.inmarsat.insertShortcode(val);
            this.$refs.billing.insertShortcode(val);
            this.$refs.mss.insertShortcode(val);
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
